import Vue from "vue";
import VueRouter from "vue-router";
import VueBodyClass from "vue-body-class";

Vue.use(VueRouter);

const title = "Emennu - Cardápio online e digital"
//const bodyClass = "foodkuy-blue"
const metaTags = [{
    name: "title",
    content: "Emennu - Cardápio online e digital"
  },
  {
    name: "description",
    content: "Seu cardápio fácil, prático e simples para seus clientes, com leitura via QRCode, link com iFood, Waze, WhatsApp e Redes Sociais."
  },
  {
    name: "image",
    content: "https://emennu.com.br/img/emennu_FINAL.png"
  }, {
    name: "og:title",
    content: "Emennu - Cardápio online e digital"
  },
  {
    name: "og:description",
    content: "Seu cardápio fácil, prático e simples para seus clientes, com leitura via QRCode, link com iFood, Waze, WhatsApp e Redes Sociais."
  },
  {
    name: "og:image",
    content: "https://emennu.com.br/img/emennu_FINAL.png"
  },
  {
    name: "og:locale",
    content: "pt_BR"
  },
  {
    name: "og:type",
    content: "website"
  },
  {
    name: "og:url",
    content: "https://emennu.com.br/"
  },
  {
    name: "og:site_name",
    content: "Emennu"
  }
]

const routes = [{
    path: "",
    name: "Site-Home",
    component: () => import("../views/site/Home.vue"),
    meta: {
      title: title,
      metaTags: metaTags
    }
  },
  {
    path: "/:nomeUrl",
    component: () => import("../views/cardapios/Home.vue"),
    props: true,
    children: [{
      path: "",
      name: "Cardapios-Home",
      component: () => import("../views/cardapios/TiposCardapio.vue"),
      props: true,
      meta: {
        title: title,
        //bodyClass: bodyClass,
        metaTags: metaTags
      }
    }, {
      path: "cardapio",
      name: "Cardapios-Produtos",
      component: () => import("../views/cardapios/Produtos.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }, {
      path: "produto/:produtoId",
      name: "Cardapios-ProdutoDetalhe",
      component: () => import("../views/cardapios/ProdutoDetalhe.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }, {
      path: "estacionamento",
      name: "Cardapios-Estacionamento",
      component: () => import("../views/cardapios/Estacionamento.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }, {
      path: "filaespera",
      name: "Cardapios-FilaEspera",
      component: () => import("../views/cardapios/FilaEspera.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }, {
      path: "areapet",
      name: "Cardapios-AreaPet",
      component: () => import("../views/cardapios/AreaPet.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }, {
      path: "formaspagamento",
      name: "Cardapios-FormasPagamento",
      component: () => import("../views/cardapios/FormasPagamento.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }, {
      path: "happypromocoes",
      name: "Cardapios-HappyPromocoes",
      component: () => import("../views/cardapios/HappyPromocoes.vue"),
      props: true,
      meta: {
        title: title,
        metaTags: metaTags
      }
    }]
  }
  // , {
  //   path: "/a/admin",
  //   component: () => import("../views/admin/login/Home.vue"),
  //   children: [{
  //     path: "",
  //     name: "Admin-Login",
  //     component: () => import("../views/admin/login/Login.vue")
  //   }, {
  //     path: "produtos",
  //     name: "Admin-Produtos",
  //     component: () => import("../views/admin/login/Produtos.vue")
  //   }, {
  //     path: "produtos/itens",
  //     name: "Admin-Itens",
  //     component: () => import("../views/admin/login/Itens.vue")
  //   }]
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: 120
        }
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes
});

const vueBodyClass = new VueBodyClass(routes);
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  document.metaTags = to.meta.metaTags;
  vueBodyClass.guard(to, next);
});

export default router;